import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useDesignContext } from '@klarna/designtokens';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { useInteractiveStateCombined } from '@bubble-ui/hook-use-interactive-state';
import Text from '@bubble-ui/primitive-text';
import Touchable from '@bubble-ui/primitive-touchable';
import View from '@bubble-ui/primitive-view';
import { defaultDesignTokens } from '../defaultDesignTokens';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
import { getIds } from './getIds';
var DatePickerDayComponent = _ref => {
  var {
    disabled: passedDisabledProp,
    dueDate,
    hovered: passedHoveredProp,
    id,
    inline,
    isDayLabel,
    isToday,
    focused: passedFocusedProp,
    keyboardFocused: passedKeyboardFocusedProp,
    label,
    onBlur,
    onClick,
    onFocus,
    onMouseDown,
    onMouseOver,
    onMouseOut,
    onMouseUp,
    onPressIn,
    onPressOut,
    onTouchEnd,
    onTouchStart,
    pressed: passedPressedProp,
    rangeEnd,
    rangeSelected,
    rangeStart,
    selected,
    withinRange
  } = _ref;
  var designContext = useDesignContext(defaultDesignTokens);
  var ids = getIds(id);
  var [{
    hovered,
    disabled,
    keyboardFocused,
    pressed
  }, eventHandlers] = useInteractiveStateCombined({
    disabled: passedDisabledProp,
    focused: passedFocusedProp,
    hovered: passedHoveredProp,
    keyboardFocused: passedKeyboardFocusedProp,
    onBlur,
    onFocus,
    onMouseDown,
    onMouseOver,
    onMouseOut,
    onMouseUp,
    onPressIn,
    onPressOut,
    onTouchEnd,
    onTouchStart,
    pressed: passedPressedProp
  });
  var {
    buttonStyle,
    colorizerStyle,
    focusStyle,
    focusWrapperStyle,
    todayStyle,
    todayWrapperStyle,
    dueDateIndicatorStyle,
    dueDateIndicatorWrapperStyle,
    leftSideBackgroundStyle,
    rightSideBackgroundStyle,
    wrapperStyle,
    dayNumberStyle,
    weekdayLabelStyle
  } = getDefaultStyleSheet({
    designContext,
    disabled,
    dueDate,
    hovered,
    inline,
    isDayLabel,
    keyboardFocused,
    label,
    pressed,
    rangeEnd,
    rangeSelected,
    rangeStart,
    selected,
    withinRange
  });
  return /*#__PURE__*/React.createElement(Touchable, _extends({
    disabled: disabled || isDayLabel || label == null || label === '',
    id: ids === null || ids === void 0 ? void 0 : ids.root,
    onPress: onClick,
    style: buttonStyle
  }, eventHandlers), /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.wrapper,
    style: wrapperStyle
  }, /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.leftSideBackground,
    style: leftSideBackgroundStyle
  }), /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.rightSideBackground,
    style: rightSideBackgroundStyle
  }), /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.colorizer,
    style: colorizerStyle
  }, /*#__PURE__*/React.createElement(Text, {
    numberOfLines: 0,
    tag: "paragraph",
    style: isDayLabel ? weekdayLabelStyle : dayNumberStyle
  }, label)), !isDayLabel && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.focusWrapper,
    style: focusWrapperStyle
  }, /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.focus,
    style: focusStyle
  })), isToday && /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.todayWrapper,
    style: todayWrapperStyle
  }, /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.today,
    style: todayStyle
  })), /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.dueDateIndicatorWrapper,
    style: dueDateIndicatorWrapperStyle
  }, /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.dueDateIndicator,
    style: dueDateIndicatorStyle
  })))));
};
DatePickerDayComponent.displayName = 'DatePickerDay';
export var DatePickerDay = withProvisionalOverrideFromContext(DatePickerDayComponent);
//# sourceMappingURL=index.js.map